import React from 'react';
import { translate } from 'react-i18next';

import AccountNav from 'components/account/AccountNav.js';
import ContactInfo from 'components/account/AccountInfo.js';
import PasswordChange from 'components/account/AccountPassword.js';
import AccountCalloutPreferences from 'components/account/AccountCalloutPreferences';
import AccountSettings from 'components/account/AccountSettings';
import AccountCalendarSync from 'components/account/AccountCalendarSync.js';
import AccountMobileApps from 'components/account/AccountMobileApps.js';
import AccountHelpSupport from 'components/account/AccountHelpSupport.js';
import BrandFooter from 'components/BrandFooter.js';

import AccountActions from 'actions/AccountActions.js';
import UserActions from 'actions/UserActions.js';
import UserSettingActions from 'actions/UserSettingActions.js';

class AccountView extends React.Component {
  constructor(props) {
    super(props);
    this.lastUser = null;
    this.state = {
      calendarOptin: false,
      preferencesLoaded: false,
      activeState: 'default',
      activePage: 'contact',
      user: {},
      settings: {},
      statuses: [],
      password_preferences: {},
      shareData: [],
      advancedCalloutOptions: false,
      multiFormatNotificationsEnabled: false,
      dropAndExchangeNotificationsEnabled: false,
      allowExchangesAndDrops: false,
      allowShiftsWithScheduledShiftConflict: false,
      allowShiftsWithTimeOffConflict: false,
    };
    this.onClickHandler = this.onClickHandler.bind(this);
  }

  componentWillUnmount() {
    // remove store event handlers
    AccountStore.off(null, null, this);
    UserSettingsStore.off(null, null, this);
    UserStore.off(null, null, this);
  }

  componentDidMount() {
    Utils.enableGlobalSpinner();

    AccountStore.on(
      'core:account:load:success',
      function (account) {
        this.setState({
          user: account,
          advancedCalloutOptions: account.company.advanced_callout_options,
          multiFormatNotificationsEnabled: account.company.multi_format_notifications_enabled,
          dropAndExchangeNotificationsEnabled:
            account.company.drop_and_exchange_notifications_enabled,
          allowExchangesAndDrops: account.company.allow_exchanges_and_drops,
          allowShiftsWithScheduledShiftConflict:
            account.company.allow_shifts_with_scheduled_shift_conflict,
          allowShiftsWithTimeOffConflict: account.company.allow_shifts_with_time_off_conflict,
        });

        UserSettingActions.getSettings(account.id);
      },
      this,
    );

    UserSettingsStore.on(
      'user:settings:load:success',
      function (data) {
        this.setState({
          settings: data,
        });
        Utils.removeSpinner();
      },
      this,
    );

    UserSettingsStore.on(
      'user:settings:change:reload',
      function (data) {
        this.setState({
          settings: data,
          statuses: this.state.statuses,
        });
      },
      this,
    );

    UserSettingsStore.on(
      'user:settings:update:success',
      function (data) {
        if (data.locale) Utils.setLocale(data.locale);
        this.state.statuses.push({
          title: this.props.t('AccountView.success'),
          message: this.state.activePage == 'preferences'
            ? this.props.t('AccountView.notification_preferences_success')
            : this.props.t('AccountView.account_settings_success'),
          status: 'success',
          key: _.uniqueId(),
        });
        this.setState({
          statuses: this.state.statuses,
        });
      },
      this,
    );

    UserSettingsStore.on(
      'user:settings:update:error',
      function (data) {
        this.state.statuses.push({
          title: this.props.t('AccountView.error'),
          message: data,
          status: 'error',
          key: _.uniqueId(),
        });
        this.setState({
          statuses: this.state.statuses,
        });
      },
      this,
    );

    AccountStore.on(
      'account:updateSuccess',
      function (data) {
        this.state.statuses.push({
          title: this.props.t('AccountView.success'),
          message: this.props.t('AccountView.account_settings_success'),
          status: 'success',
          key: _.uniqueId(),
        });
        this.setState({
          user: data,
          statuses: this.state.statuses,
        });
      },
      this,
    );

    AccountStore.on(
      'account:updateError',
      function (data) {
        this.state.statuses.push({
          title: this.props.t('AccountView.error'),
          message: data,
          status: 'error',
          key: _.uniqueId(),
        });
        this.setState({
          statuses: this.state.statuses,
        });
      },
      this,
    );

    AccountStore.on(
      'password:update:success',
      function (data) {
        this.state.statuses.push({
          title: this.props.t('AccountView.success'),
          message: this.props.t('AccountView.changed_password_success'),
          status: 'success',
          key: _.uniqueId(),
        });
        this.setState({
          statuses: this.state.statuses,
          password_preferences: data,
        });
      },
      this,
    );

    AccountStore.on(
      'password:update:failed',
      function (data) {
        this.state.statuses.push({
          title: this.props.t('AccountView.error'),
          message: data.errors,
          status: 'error',
          key: _.uniqueId(),
        });
        this.setState({
          statuses: this.state.statuses,
          password_preferences: data,
        });
      },
      this,
    );

    UserStore.on(
      'user:shared:sent:calendar:removed',
      function (response, collection) {
        this.state.statuses = [];
        this.state.statuses.push({
          title: this.props.t('AccountView.success'),
          message: this.props.t('AccountView.shared_schedule_removed_success'),
          status: 'success',
          key: _.uniqueId(),
        });
        this.setState({
          statuses: this.state.statuses,
        });

        UserActions.getSharedCalendar();
      },
      this,
    );

    UserStore.on(
      'user:shared:sent:calendar:success',
      function (response) {
        this.state.statuses = [];
        const shareData = _.clone(this.state.shareData);
        shareData.push(response.data);
        this.setState({
          shareData,
          calendarOptin: true,
        });
        if (Utils.getCoreUser().email.toLowerCase() != response.data.email.toLowerCase()) {
          this.state.statuses.push({
            title: this.props.t('AccountView.success'),
            message: this.props.t('AccountView.shared_schedule_success', { email: response.data.email }),
            status: 'success',
            key: _.uniqueId(),
          });
          this.setState({
            statuses: this.state.statuses,
          });
        }
      },
      this,
    );

    UserStore.on(
      'user:shared:calendar:success',
      function (response) {
        // if the data length is zero, then we need to create the initial scheduleshare.
        if (response.data.length == 0) {
          const email = this.state.user.email || Utils.getCoreUser().email;
          UserActions.sendSharedCalendar(email, true);
        } else {
          this.setState({
            shareData: response.data,
            calendarOptin: true,
          });
        }
      },
      this,
    );

    if (!Utils.isNotDefined(Utils.getCoreUser())) {
      AccountActions.getCoreAccount();
      UserActions.getSharedCalendar();
    }
  }

  onClickHandler(currentButton) {
    this.setState({
      activePage: currentButton,
      statuses: [],
    });
  }

  closeAllStatusDialogs() {
    this.state.statuses = [];
    this.setState({
      statuses: this.state.statuses,
    });
  }

  closeStatusDialog(props) {
    const len = this.state.statuses.length;
    for (let i = 0; i < len; i++) {
      if (props.status.key == this.state.statuses[i].key) {
        this.state.statuses.splice(i, 1);
        break;
      }
    }
    this.setState({
      statuses: this.state.statuses,
    });
  }

  updateUser(props) {
    this.setState({ user: props });
  }

  render() {
    let preferences;
    let requiresValidPhoneNumber = false;
    let { calendarOptin } = this.state;
    const {
      settings, shareData, advancedCalloutOptions, multiFormatNotificationsEnabled,
      dropAndExchangeNotificationsEnabled, allowExchangesAndDrops,
      allowShiftsWithScheduledShiftConflict, allowShiftsWithTimeOffConflict,
    } = this.state;

    if (_.isEmpty(this.state.user)) {
      return false;
    }

    if (calendarOptin) {
      if (_.isUndefined(shareData)) {
        calendarOptin = false;
      }
    }

    if (!_.isEmpty(settings)) {
      preferences = settings.preferences;
      if (!_.isUndefined(preferences) && !_.isNull(preferences)) {
        _.each(preferences, (preference) => {
          if (_.some(preference, preference => preference == 'phone' || preference == 'sms')) {
            requiresValidPhoneNumber = true;
          }
        });
      }
    }

    return (
      <div>
        <section id="account">
          <aside>
            <AccountNav
              activePage={this.state.activePage}
              advancedCalloutOptions={advancedCalloutOptions}
              multiFormatNotificationsEnabled={multiFormatNotificationsEnabled}
              onClickHandler={this.onClickHandler.bind(this)}
            />
          </aside>
          <main>
            <ContactInfo
              activeState={this.state.activePage == 'contact' ? 'active' : 'hidden'}
              user={this.state.user ? this.state.user : {}}
              statuses={this.state.statuses ? this.state.statuses : []}
              closeStatusDialog={this.closeStatusDialog.bind(this)}
              updateUser={this.updateUser.bind(this)}
              validatePhone={requiresValidPhoneNumber}
            />
            <PasswordChange
              activeState={this.state.activePage == 'password' ? 'active' : 'hidden'}
              user={this.state.user ? this.state.user : {}}
              statuses={this.state.statuses ? this.state.statuses : []}
              closeStatusDialog={this.closeAllStatusDialogs.bind(this)}
              password_preferences={
                this.state.password_preferences ? this.state.password_preferences : {}
              }
            />
            <AccountCalloutPreferences
              activeState={this.state.activePage == 'preferences' ? 'active' : 'hidden'}
              user={this.state.user ? this.state.user : {}}
              statuses={this.state.statuses ? this.state.statuses : ''}
              closeStatusDialog={this.closeStatusDialog.bind(this)}
              settings={this.state.settings ? this.state.settings : ''}
              calloutPreferences={preferences}
              advancedCalloutOptions={advancedCalloutOptions}
              multiFormatNotificationsEnabled={multiFormatNotificationsEnabled}
              dropAndExchangeNotificationsEnabled={dropAndExchangeNotificationsEnabled}
              allowExchangesAndDrops={allowExchangesAndDrops}
              allowShiftsWithScheduledShiftConflict={allowShiftsWithScheduledShiftConflict}
              allowShiftsWithTimeOffConflict={allowShiftsWithTimeOffConflict}
              onClickHandler={this.onClickHandler.bind(this)}
            />
            <AccountSettings
              activeState={this.state.activePage == 'settings' ? 'active' : 'hidden'}
              statuses={this.state.statuses ? this.state.statuses : []}
              closeStatusDialog={this.closeStatusDialog.bind(this)}
            />
            <AccountCalendarSync
              activeState={this.state.activePage == 'calendar' ? 'active' : 'hidden'}
              shouldRender={calendarOptin}
              closeStatusDialog={this.closeStatusDialog.bind(this)}
              statuses={this.state.statuses ? this.state.statuses : ''}
              user={this.state.user ? this.state.user : {}}
              shareData={shareData}
            />
            <AccountMobileApps
              activeState={this.state.activePage == 'mobile' ? 'active' : 'hidden'}
            />
            <AccountHelpSupport
              activeState={this.state.activePage == 'help' ? 'active' : 'hidden'}
            />
            <BrandFooter
              brand={window.EmployeeWeb.ENVConfig.brand}
              key={_.uniqueId()}
              year={new Date().getFullYear()}
              privacyLink={window.EmployeeWeb.ENVConfig.privacy_link}
              termsLink={window.EmployeeWeb.ENVConfig.terms_link}
            />
          </main>
        </section>
      </div>
    );
  }
}

export default translate()(AccountView);
